var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLibrary = function SvgLibrary(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.89 3.956H1.96v7.93h4.932v-7.93ZM6.89 12.547H1.96v3.304h4.932v-3.304ZM6.89 16.512H1.96v1.982h4.932v-1.982ZM12.809 1.313H7.877v8.59h4.932v-8.59ZM12.809 10.564H7.877v3.304h4.932v-3.304ZM12.809 14.53H7.877v3.964h4.932V14.53ZM18.727 5.938h-4.932v5.948h4.932V5.938ZM18.727 12.547h-4.932v3.304h4.932v-3.304ZM18.727 16.512h-4.932v1.982h4.932v-1.982Z",
    fill: "currentColor"
  })));
};
export default SvgLibrary;